import {Flex, Icon, ListItem, PriorityIcon, Text} from '@priority-software/priority-style-react';
import React from 'react';
import {MacroMenuDropdown} from '../../Macros/MacroMenuDropdown';
import {useHover} from '../../../../../hooks/useHover';
import {OldMacroSubMenu} from './OldMacroSubmenu';
import {AutomationSettingsItem, macroItem} from '../constants';
import {handleUnsupportedFeature} from '../../../../Form/actions/handleUnsupportedFeature';
import {isCurrentEntityReactForm} from '../../../../../_shared/GWTBridge/invoke/genPage';

type Props = {
    isOpenSubmenu: boolean;
    index: number;
    currentFocusedIndex: number;
    handleShowHelp: (e, desc: string) => void;
    handleOpenSubMenu: () => void;
    openMacro: (item: AutomationSettingsItem) => void;
    handleClose: () => void;
    closeSubMenu: () => void;
    useBridgeAPI: boolean;
};

const showMacrosSubmenu = false;

export const MacroItem = ({
    isOpenSubmenu,
    index,
    currentFocusedIndex,
    handleShowHelp,
    handleOpenSubMenu,
    openMacro,
    handleClose,
    closeSubMenu,
    useBridgeAPI
}: Props) => {
    const {setRef, isHovering} = useHover();

    return (
        <ListItem
            key={macroItem.title}
            ref={setRef}
            onClick={
                isCurrentEntityReactForm()
                    ? () => handleUnsupportedFeature('Macros')
                    : handleOpenSubMenu
            }
            isFocused={currentFocusedIndex === index}
            componentClasses="ignore-react-onclickoutside"
            isActive={false}
        >
            {!useBridgeAPI ? (
                <Flex justifyContent="space-between">
                    <Flex justifyContent="flex-start">
                        <Text tag="div" skin="paragraph-1">
                            {macroItem.title}
                        </Text>
                        {isHovering && (
                            <Icon
                                icon={PriorityIcon.help}
                                onClick={e => handleShowHelp(e, macroItem.desc)}
                            />
                        )}
                    </Flex>
                    {showMacrosSubmenu ? (
                        <MacroMenuDropdown
                            isOpen={isOpenSubmenu}
                            openMacro={openMacro}
                            closeSubMenu={handleOpenSubMenu}
                        />
                    ) : null}
                </Flex>
            ) : (
                <OldMacroSubMenu
                    isSubmenuOpen={isOpenSubmenu}
                    handleClose={handleClose}
                    handleCloseSubMenu={closeSubMenu}
                    isHovering={isHovering}
                    useBridgeAPI={useBridgeAPI}
                    handleShowHelp={handleShowHelp}
                />
            )}
        </ListItem>
    );
};
